































import Vue from "vue";
import AdminPortalGroupsTable from "@/components/AdminPortalGroupsTable.vue";
import AdminPortalTable from "@/components/AdminPortalTable.vue";
import USERS_QUERY from "@/graphql/UsersQuery.gql";
import TRAINER_PARTICIPANTS_QUERY from "@/graphql/TrainerParticipantsQuery.gql";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import Component from "vue-class-component";

@Component({
  name: "AdminManagementTable",
  components: { AdminPortalTable, AdminPortalGroupsTable },
  apollo: {
    allUsersResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          paginationParams: {
            page: this.allUserTableOptions.options.page,
            perPage: this.allUserTableOptions.options.itemsPerPage
          }
        };
      },
      skip() {
        return this.$authRepository.getCurrentUser()?.imgRole != RoleEnum.ADMIN;
      },
      result({ data, loading }) {
        if (!loading) {
          this.allUserTableOptions.serverItemsLength = data.users.meta.totalCount;
          this.allUserTableOptions.items = data.users.users.map((user: any) => ({
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            imgRole: user.imgRole,
            phone: user.phone,
            id: user.id,
            editPath: "users_edit_path"
          }));
        }
      }
    },
    allAdminResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          paginationParams: {
            page: this.allAdminTableOptions.options.page,
            perPage: this.allAdminTableOptions.options.itemsPerPage
          },
          filterParams: {
            roles: [RoleEnum.ADMIN]
          }
        };
      },
      skip() {
        return this.$authRepository.getCurrentUser()?.imgRole != RoleEnum.ADMIN;
      },
      result({ data, loading }) {
        if (!loading) {
          this.allAdminTableOptions.serverItemsLength = data.users.meta.totalCount;
          this.allAdminTableOptions.items = data.users.users.map((user: any) => ({
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            imgRole: user.imgRole,
            phone: user.phone,
            id: user.id,
            editPath: "users_edit_path"
          }));
        }
      }
    },
    allTrainersResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          paginationParams: {
            page: this.allTrainerTableOptions.options.page,
            perPage: this.allTrainerTableOptions.options.itemsPerPage
          },
          filterParams: {
            roles: [RoleEnum.TRAINER]
          }
        };
      },
      skip() {
        return this.$authRepository.getCurrentUser()?.imgRole != RoleEnum.ADMIN;
      },
      result({ data, loading }) {
        if (!loading) {
          this.allTrainerTableOptions.serverItemsLength = data.users.meta.totalCount;
          this.allTrainerTableOptions.items = data.users.users.map((user: any) => ({
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            imgRole: user.imgRole,
            phone: user.phone,
            id: user.id,
            editPath: "users_edit_path"
          }));
        }
      }
    },
    allParticipantsResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          paginationParams: {
            page: this.allParticipants.options.page,
            perPage: this.allParticipants.options.itemsPerPage
          },
          filterParams: {
            roles: [RoleEnum.PARTICIPANT]
          }
        };
      },
      skip() {
        return this.$authRepository.getCurrentUser()?.imgRole != RoleEnum.ADMIN;
      },
      result({ data, loading }) {
        if (!loading) {
          this.allParticipants.serverItemsLength = data.users.meta.totalCount;
          this.allParticipants.items = data.users.users.map((user: any) => ({
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            imgRole: user.imgRole,
            phone: user.phone,
            id: user.id,
            editPath: "users_edit_path"
          }));
        }
      }
    },
    trainerParticipantsResponse: {
      query: TRAINER_PARTICIPANTS_QUERY,
      manual: true,
      skip() {
        return this.$authRepository.getCurrentUser()?.imgRole != RoleEnum.TRAINER;
      },
      variables() {
        return {
          paginationParams: {
            page: this.allParticipants.options.page,
            perPage: this.allParticipants.options.itemsPerPage
          }
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.allParticipants.serverItemsLength = data.trainerParticipants.meta.totalCount;
          this.allParticipants.items = data.trainerParticipants.users.map((user: any) => ({
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            imgRole: user.imgRole,
            phone: user.phone,
            id: user.id,
            editPath: "users_edit_path"
          }));
        }
      }
    }
  }
})
export default class AdminManagementTable extends Vue {
  headers = [
    { text: "Name", value: "name" },
    { text: "Email", value: "email" },
    { text: "Role", value: "imgRole" },
    { text: "Phone Number", value: "phone" },
    { text: "Actions", value: "action" }
  ];
  allParticipants = {
    headers: this.headers,
    options: { page: 1, itemsPerPage: 10 },
    items: [],
    serverItemsLength: 0
  };
  allTrainerTableOptions = {
    headers: this.headers,
    options: { page: 1, itemsPerPage: 10 },
    items: [],
    serverItemsLength: 0
  };
  allAdminTableOptions = {
    headers: this.headers,
    options: { page: 1, itemsPerPage: 10 },
    items: [],
    serverItemsLength: 0
  };
  allUserTableOptions = {
    headers: this.headers,
    options: { page: 1, itemsPerPage: 10 },
    items: [],
    serverItemsLength: 0
  };

  get userIsTrainer(): boolean {
    return this.$authRepository.getCurrentUser()?.imgRole == RoleEnum.TRAINER;
  }

  get userIsAdmin(): boolean {
    return this.$authRepository.getCurrentUser()?.imgRole == RoleEnum.ADMIN;
  }
}
